import React, { Fragment, useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Skeleton } from '@mui/material';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

const ImgLoader = ({
  src,
  fallbackSrc,
  fallbackComponent,
  skeletonClassName,
  alt,
  minHeight,
  ...rest
}) => {
  const [imgSrc, setImgSrc] = useState(src);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isErrored, setIsErrored] = useState(false);
  const {
    width,
    height,
  } = { ...rest };

  const onError = () => {
    if (fallbackSrc !== null && fallbackSrc !== imgSrc) {
      setImgSrc(fallbackSrc);
    } else {
      setIsLoaded(true);
      setIsErrored(true);
    }
  };

  useEffect(() => {
    setIsLoaded(false);
    setImgSrc(src);
    setIsErrored(false);
  }, [src]);

  const sx = { margin: 'auto' };
  return (
    !_.isEmpty(fallbackComponent) && isErrored ? (
      fallbackComponent
    ) : (
      <Fragment>
        {!isLoaded && (
          <Skeleton
            variant="rectangular"
            component="div"
            width={width}
            height={height || minHeight}
            sx={sx}
            className={skeletonClassName}
          />
        )}
        <Zoom zoomImg={{ src: imgSrc }} zoomMargin={80}>
          <img
            src={imgSrc}
            style={isLoaded ? sx : {
              ...sx, width: 0, height: 0, border: 'none',
            }}
            onLoad={() => setIsLoaded(true)}
            onError={onError}
            alt={alt}
            {...rest}
          />
        </Zoom>
      </Fragment>
    )
  );
};

ImgLoader.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  fallbackComponent: PropTypes.node,
  fallbackSrc: PropTypes.string,
  height: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  loading: PropTypes.string,
  minHeight: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  skeletonClassName: PropTypes.string,
  src: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
};

ImgLoader.defaultProps = {
  alt: 'Image with no alt text',
  className: '',
  fallbackComponent: null,
  fallbackSrc: null,
  height: null,
  loading: '',
  minHeight: null,
  skeletonClassName: '',
};

export default ImgLoader;
